var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-trend"},[_vm._m(0),_c('div',{staticClass:"chart-container"},[_c('div',{ref:"chartRef",staticClass:"chart"})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-header"},[_c('h3',{staticClass:"module-title"},[_vm._v("会员活跃趋势")])])
}]

export { render, staticRenderFns }